import type { Variants } from 'framer-motion'

export const SHADOW_REST =
  '0 1px 2px color-mix(in srgb, var(--mantine-color-primary-9) 4%, transparent), 0 2px 6px color-mix(in srgb, var(--mantine-color-primary-9) 5%, transparent)'
const SHADOW_HOVER =
  '0 8px 20px color-mix(in srgb, var(--mantine-color-primary-9) 12%, transparent), 0 3px 8px color-mix(in srgb, var(--mantine-color-primary-9) 7%, transparent)'

/**
 * Shared framer-motion hover variants for interactive cards. The parent sets
 * `whileHover="hover"`; children with matching variant keys (arrow, accent)
 * animate via framer's variant propagation.
 */
export const liftVariants: Variants = {
  rest: { y: 0, boxShadow: SHADOW_REST },
  hover: { y: -3, boxShadow: SHADOW_HOVER }
}

/** Hover that only raises the shadow — the card itself does not move. */
export const shadowVariants: Variants = {
  rest: { boxShadow: SHADOW_REST },
  hover: { boxShadow: SHADOW_HOVER }
}

export const arrowVariants: Variants = {
  rest: { x: 0 },
  hover: { x: 4 }
}

export const accentVariants: Variants = {
  rest: { scaleY: 0 },
  hover: { scaleY: 1 }
}
